import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { SiteContentProvider } from "./hooks/useSiteContent";
import Home from "./pages/Home";
import MarketingPage from "./pages/MarketingPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <I18nProvider>
      <SiteContentProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#161A23",
              border: "1px solid #2A303C",
              color: "#E0E4EB",
              borderRadius: 0,
              fontFamily: "Inter, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/marketing" element={<MarketingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      </SiteContentProvider>
    </I18nProvider>
  );
}

export default App;
